import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { adminTotpVerify } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ShieldCheck, ArrowRight } from "lucide-react";

export default function AdminVerify() {
  const navigate = useNavigate();
  const location = useLocation();
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const returnTo = location.state?.from || "/admin";

  const onVerify = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setSubmitting(true);
    try {
      await adminTotpVerify(code.trim());
      toast.success("Verificación completada");
      navigate(returnTo === "/admin/verify" ? "/admin" : returnTo, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : detail?.error === "totp_setup_required" ? "Debes configurar 2FA primero" : "Código incorrecto";
      toast.error(msg);
      if (detail?.error === "totp_setup_required") {
        navigate("/admin/setup", { replace: true });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="admin-verify-page">
      <div className="w-full max-w-md">
        <Link to="/dashboard" className="text-[12px] text-foreground/55 hover:text-foreground transition-colors mb-6 inline-block">
          ← Volver al dashboard
        </Link>
        <div className="app-card p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded-xl bg-foreground text-white grid place-items-center">
              <ShieldCheck className="w-5 h-5" />
            </div>
            <div>
              <h1 className="font-display text-2xl font-black leading-tight">Verificación 2FA</h1>
              <p className="text-xs text-foreground/55">Introduce el código de tu app.</p>
            </div>
          </div>

          <form onSubmit={onVerify} className="space-y-3">
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              pattern="[0-9]*"
              maxLength={8}
              placeholder="000000"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              className="w-full px-4 py-4 rounded-xl border border-black/[0.08] bg-white text-center text-2xl font-mono tracking-[0.5em] focus:outline-none focus:border-foreground/40"
              data-testid="admin-verify-code-input"
              autoFocus
              required
            />
            <button
              type="submit"
              disabled={submitting || code.length < 6}
              className="w-full py-3 rounded-xl bg-foreground text-white text-[13px] font-medium disabled:opacity-50 flex items-center justify-center gap-2"
              data-testid="admin-verify-submit-btn"
            >
              {submitting ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <>Verificar <ArrowRight className="w-4 h-4" /></>
              )}
            </button>
          </form>

          <p className="text-[11px] text-foreground/55 mt-6 text-center">
            La sesión admin dura 30 minutos. Después se pedirá otro código.
          </p>
        </div>
      </div>
    </div>
  );
}
